import React, { useEffect, useRef, useState } from 'react'
import './archived-games-container.styles.scss';
import AgeCheck from '@/components/layout-auth/age-check/age-check.component';
import { useSelector } from 'react-redux';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { useNavigate } from 'react-router-dom';
import { getGameDataFromDb } from '@/utils/getDataFromDb';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';

const ArchivedGamesContainer = ({
    archivedList
}) => {
    
    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ gamesToDisplay, setGamesToDisplay ] = useState([]);
    const navigate = useNavigate();
    const gamesRef = useRef({});

    useEffect(() => {
        Object.values(archivedList).map(game => {
            console.log(game);
            getGameData(game);
        })
    }, [archivedList])


    function getGameData(game) {
        getGameDataFromDb({
            'gameId': game.gameId,
            'once': true,
            'callback': callback,
        })    

        function callback(gameData) {
            gamesRef.current = {
                ...gamesRef.current,
                [gameData.gameId]: gameData
            }
            setGamesToDisplay(Object.values(gamesRef.current));
        }
    }

    return (
        <div className='archived-games-container'>
            <AgeCheck />
            {/* <Layout> */}
            <div className={`archived-games-content ${screenSize}`}>
                <div className={`g-card`}>
                    <BackButton cancel={() => navigate(-1)} />
                    <div className="g-space-1"></div>
                    <div className='section-title'>
                        Archived Games
                    </div>
                    <hr />
                    <div className={`archived-games-list ${screenSize}`}>
                    {
                        (gamesToDisplay) &&
                        gamesToDisplay
                        .sort((a,b) => a.gameName.toLowerCase() > b.gameName.toLowerCase() ? 1 : -1)
                        .map(g => {
                            return (
                                <div key={g.gameId} className='archived-game-item g-list-item'>
                                    <div className='archived-game-icon'>
                                        <ImageContainer
                                            src={g.icon}
                                            alt={g.gameName} />
                                    </div>
                                    <div className='archived-game-name'>
                                        {g.gameName}
                                    </div>
                                    <div className='archived-game-date meta'>
                                        Elements: {g.createdElementTotal ?? 0}<br />
                                        Players: {g.playerCount ?? 0}<br />

                                        Archived: {new Date(g.ts_archived).toLocaleDateString()}
                                    </div>
                                    <div className='buttons'>
                                        <button 
                                            className='g-button med-btn' 
                                            onClick={() => navigate(g.path)}>View</button>
                                        <button 
                                            className='g-button med-btn'>
                                            Reinstate
                                        </button> 
                                    </div>
                                </div>
                            )
                        })
                    }                
                    </div>
                </div>
                <div className="g-space-1"></div>
            </div>
        </div>
    )
}

export default ArchivedGamesContainer